/* =====================================================
   Adele Chérie — Search Amazon-style v1
   Predictive autocomplete · Recent (localStorage) · Keyboard nav
   ===================================================== */

(function() {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__acSearchInit) return;
  window.__acSearchInit = true;

  var RECENT_KEY = 'ac_recent_searches';
  var RECENT_MAX = 8;
  var DEBOUNCE_MS = 220;
  var MIN_CHARS = 2;

  var state = {
    container: null,
    input: null,
    panels: {},
    abortController: null,
    debounceTimer: null,
    highlightedIndex: -1,
    suggestions: [],
    products: [],
    collections: [],
    pages: [],
    currentQuery: ''
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function init() {
    state.container = $('[data-ac-search]');
    if (!state.container) return;

    state.input = $('[data-ac-search-input]', state.container);
    state.panels = {
      idle: $('[data-ac-search-idle]', state.container),
      loading: $('[data-ac-search-loading]', state.container),
      results: $('[data-ac-search-results]', state.container),
      empty: $('[data-ac-search-empty]', state.container)
    };

    // ===== Open/close triggers (delega su tutto il doc) =====
    document.addEventListener('click', function(e) {
      var open = e.target.closest('[data-ac-search-open]');
      var close = e.target.closest('[data-ac-search-close]');
      if (open) {
        e.preventDefault();
        openSearch();
      } else if (close) {
        e.preventDefault();
        closeSearch();
      }
    });

    // ESC chiude
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && state.container.getAttribute('aria-hidden') === 'false') {
        closeSearch();
      }
      if (state.container.getAttribute('aria-hidden') === 'false') {
        handleKeyboardNav(e);
      }
    });

    // Input typing
    state.input.addEventListener('input', function() {
      var q = state.input.value.trim();
      var clearBtn = $('[data-ac-search-clear]', state.container);
      if (clearBtn) clearBtn.hidden = q.length === 0;

      clearTimeout(state.debounceTimer);
      if (q.length < MIN_CHARS) {
        showPanel('idle');
        state.highlightedIndex = -1;
        return;
      }
      state.debounceTimer = setTimeout(function() { runSearch(q); }, DEBOUNCE_MS);
    });

    // Form submit: salva recent + naviga
    var form = $('[data-ac-search-form]', state.container);
    if (form) {
      form.addEventListener('submit', function(e) {
        var q = state.input.value.trim();
        if (q.length < 1) {
          e.preventDefault();
          return;
        }
        saveRecent(q);
      });
    }

    // Clear input
    var clearBtn = $('[data-ac-search-clear]', state.container);
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        state.input.value = '';
        clearBtn.hidden = true;
        showPanel('idle');
        state.input.focus();
      });
    }

    // Click su chip / suggestion → salva recent + naviga
    state.container.addEventListener('click', function(e) {
      var chip = e.target.closest('[data-ac-search-suggest]');
      if (chip) {
        saveRecent(chip.getAttribute('data-ac-search-suggest'));
      }
      var prod = e.target.closest('.ac-search__product, .ac-search__suggestion');
      if (prod) {
        var q = state.input.value.trim();
        if (q) saveRecent(q);
      }
    });

    // Clear recent
    var clearRecentBtn = $('[data-ac-search-recent-clear]', state.container);
    if (clearRecentBtn) {
      clearRecentBtn.addEventListener('click', function() {
        clearRecent();
        renderRecent();
      });
    }

    // Initial render of recent (idle panel)
    renderRecent();
  }

  // ===== Open / Close =====
  function openSearch() {
    state.container.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ac-search-open');
    renderRecent();
    setTimeout(function() { state.input && state.input.focus(); }, 60);
  }
  function closeSearch() {
    state.container.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ac-search-open');
    state.highlightedIndex = -1;
  }

  // ===== Panels =====
  function showPanel(name) {
    Object.keys(state.panels).forEach(function(k) {
      if (!state.panels[k]) return;
      state.panels[k].hidden = (k !== name);
    });
  }

  // ===== Recent searches (localStorage) =====
  function getRecent() {
    try {
      var raw = localStorage.getItem(RECENT_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function saveRecent(query) {
    if (!query || query.length < 2) return;
    var arr = getRecent().filter(function(q) { return q.toLowerCase() !== query.toLowerCase(); });
    arr.unshift(query);
    if (arr.length > RECENT_MAX) arr = arr.slice(0, RECENT_MAX);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function clearRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
  }
  function renderRecent() {
    var wrap = $('[data-ac-search-recent]', state.container);
    var list = $('[data-ac-search-recent-list]', state.container);
    if (!wrap || !list) return;
    var arr = getRecent();
    if (arr.length === 0) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    list.innerHTML = arr.map(function(q) {
      var safe = escapeHtml(q);
      return '<li><a class="ac-search__chip" href="/search?q=' + encodeURIComponent(q) + '" data-ac-search-suggest="' + safe + '">' + safe + '</a></li>';
    }).join('');
  }

  // ===== Search via Shopify Predictive Search API =====
  function runSearch(query) {
    if (state.abortController) state.abortController.abort();
    state.abortController = new AbortController();
    state.currentQuery = query;
    showPanel('loading');

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product,collection,page,query' +
              '&resources[limit]=8&resources[options][unavailable_products]=last';

    fetch(url, { signal: state.abortController.signal, headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (query !== state.currentQuery) return; // race condition
        renderResults(data, query);
      })
      .catch(function(err) {
        if (err.name === 'AbortError') return;
        console.warn('Search error', err);
        renderEmpty(query);
      });
  }

  function renderResults(data, query) {
    var res = (data && data.resources && data.resources.results) || {};
    state.products = res.products || [];
    state.collections = res.collections || [];
    state.pages = res.pages || [];
    state.suggestions = res.queries || [];

    var totalCount = state.products.length + state.collections.length + state.pages.length + state.suggestions.length;
    if (totalCount === 0) {
      renderEmpty(query);
      return;
    }

    // Suggestions (queries)
    var secSugg = $('[data-ac-section-suggestions]', state.container);
    var listSugg = $('[data-ac-suggestions-list]', state.container);
    if (secSugg && listSugg) {
      if (state.suggestions.length > 0) {
        secSugg.hidden = false;
        listSugg.innerHTML = state.suggestions.slice(0, 5).map(function(item, idx) {
          var text = item.text || item.title || '';
          return '<li><a class="ac-search__suggestion" data-ac-idx="s-' + idx + '" href="/search?q=' + encodeURIComponent(text) + '" data-ac-search-suggest="' + escapeHtml(text) + '">' +
            highlightMatch(text, query) +
            '</a></li>';
        }).join('');
      } else {
        secSugg.hidden = true;
      }
    }

    // Products
    var secProd = $('[data-ac-section-products]', state.container);
    var listProd = $('[data-ac-products-list]', state.container);
    var viewallProd = $('[data-ac-viewall-products]', state.container);
    if (secProd && listProd) {
      if (state.products.length > 0) {
        secProd.hidden = false;
        if (viewallProd) viewallProd.href = '/search?q=' + encodeURIComponent(query);
        listProd.innerHTML = state.products.slice(0, 8).map(function(p, idx) {
          var img = p.featured_image || p.image;
          var imgUrl = img && (img.url || (typeof img === 'string' ? img : null));
          var imgHtml = imgUrl
            ? '<img src="' + imgUrl.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, '_400x.$1$2') + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
            : '<div style="background:var(--ac-warm-white);width:100%;height:100%"></div>';
          var price = p.price ? formatMoney(p.price) : '';
          var vendor = p.vendor ? '<p class="ac-search__product-vendor">' + escapeHtml(p.vendor) + '</p>' : '';
          return '<a class="ac-search__product" data-ac-idx="p-' + idx + '" href="' + p.url + '">' +
            '<div class="ac-search__product-image">' + imgHtml + '</div>' +
            vendor +
            '<p class="ac-search__product-title">' + highlightMatch(p.title, query) + '</p>' +
            '<p class="ac-search__product-price">' + price + '</p>' +
            '</a>';
        }).join('');
      } else {
        secProd.hidden = true;
      }
    }

    // Collections
    var secColl = $('[data-ac-section-collections]', state.container);
    var listColl = $('[data-ac-collections-list]', state.container);
    if (secColl && listColl) {
      if (state.collections.length > 0) {
        secColl.hidden = false;
        listColl.innerHTML = state.collections.slice(0, 6).map(function(c, idx) {
          return '<li><a data-ac-idx="c-' + idx + '" href="' + c.url + '">' +
            '<span>' + highlightMatch(c.title, query) + '</span><em>→</em></a></li>';
        }).join('');
      } else {
        secColl.hidden = true;
      }
    }

    // Pages
    var secPages = $('[data-ac-section-pages]', state.container);
    var listPages = $('[data-ac-pages-list]', state.container);
    if (secPages && listPages) {
      if (state.pages.length > 0) {
        secPages.hidden = false;
        listPages.innerHTML = state.pages.slice(0, 6).map(function(p, idx) {
          return '<li><a data-ac-idx="pg-' + idx + '" href="' + p.url + '">' +
            '<span>' + highlightMatch(p.title, query) + '</span><em>→</em></a></li>';
        }).join('');
      } else {
        secPages.hidden = true;
      }
    }

    showPanel('results');
    state.highlightedIndex = -1;
  }

  function renderEmpty(query) {
    var qEl = $('[data-ac-empty-query]', state.container);
    if (qEl) qEl.textContent = query;
    showPanel('empty');
  }

  // ===== Highlight match =====
  function highlightMatch(text, query) {
    if (!text) return '';
    if (!query) return escapeHtml(text);
    var safe = escapeHtml(text);
    var safeQ = escapeRegex(query);
    var re = new RegExp('(' + safeQ + ')', 'ig');
    return safe.replace(re, '<mark>$1</mark>');
  }

  // ===== Format money (basic, IT/EUR) =====
  // Shopify Predictive Search API (/search/suggest.json) ritorna p.price come
  // stringa già in euro decimali (es. "20.00"), NON in centesimi. Niente /100.
  function formatMoney(amount) {
    var num = parseFloat(amount);
    if (isNaN(num)) return '';
    return '€ ' + num.toFixed(2).replace('.', ',');
  }

  // ===== Keyboard navigation =====
  function handleKeyboardNav(e) {
    if (state.container.getAttribute('aria-hidden') !== 'false') return;
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
    if (state.panels.results.hidden) return;

    var items = $$('[data-ac-idx]', state.panels.results);
    if (items.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      state.highlightedIndex = (state.highlightedIndex + 1) % items.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      state.highlightedIndex = (state.highlightedIndex - 1 + items.length) % items.length;
    } else if (e.key === 'Enter' && state.highlightedIndex >= 0) {
      e.preventDefault();
      var target = items[state.highlightedIndex];
      if (target && target.href) {
        var q = state.input.value.trim();
        if (q) saveRecent(q);
        window.location.href = target.href;
      }
      return;
    }

    items.forEach(function(el, i) {
      el.classList.toggle('is-highlighted', i === state.highlightedIndex);
      if (i === state.highlightedIndex) {
        el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }

  // ===== Helpers =====
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function escapeRegex(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
